import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { WebsiteLogoSize } from '@lyceo/homi/shared/util-models';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'homi-website-logo',
  imports: [TranslocoDirective],
  templateUrl: './website-logo.component.html',
  styleUrl: './website-logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.size-small]': 'size() === WebsiteLogoSize.SMALL',
    '[class.size-medium]': 'size() === WebsiteLogoSize.MEDIUM',
    '[class.size-large]': 'size() === WebsiteLogoSize.LARGE',
  },
})
export class WebsiteLogoComponent {
  public readonly size: InputSignal<WebsiteLogoSize> = input.required();

  protected readonly WebsiteLogoSize: typeof WebsiteLogoSize = WebsiteLogoSize;
}
